<template>
  <div class="abnormal-page">
    <div class="inquire-module-list" id="page-top">
      <a-row :gutter="24">
        <a-col :md="4" :sm="6">
          <a-range-picker v-model="dateValue" format="YYYY-MM-DD" @change="changeData" />
        </a-col>
        <a-col :md="3" :sm="6">
          <a-select style="width: 100%;" placeholder="选择经办人" v-model="formData.transactorName" @change="selectAgent">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in agentList" :key="index">
              <span>{{ item.name }}</span>
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="3" :sm="6">
          <a-select style="width: 100%;" placeholder="选择发货门店" v-model="formData.storesName" @change="selectStores">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in storesList" :key="index">
              <span>{{ item.name }}</span>
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="3" :sm="6">
          <a-input placeholder="输入单据编号搜索" v-model="formData.code" />
        </a-col>
        <a-col :md="4" :sm="6" class="button-ant-col">
          <a-button class="ant-btn-color border-arc" @click="btnInquire">查询</a-button>
          <a-button class="border-arc" @click="btnResetData">重置</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="sales-order-list-table" :style="{height: contentHeight+'px'}">
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="0">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-quanbu"></span>
            <span>全部（{{ numObj.totalNumber }}）</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <abnormal-table></abnormal-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="1" force-render>
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-weiqueren"></span>
            <span>待审核（{{ numObj.notConfirm }}）</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <abnormal-table></abnormal-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-queren"></span>
            <span>审核通过待退款（{{ numObj.yesConfirm }}）</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <abnormal-table></abnormal-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-queren"></span>
            <span>审核通过已退款（{{ numObj.yesConfirm }}）</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <abnormal-table></abnormal-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="4">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-queren"></span>
            <span>审核拒绝（{{ numObj.yesConfirm }}）</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <abnormal-table></abnormal-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="5">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-queren"></span>
            <span>已撤回（{{ numObj.yesConfirm }}）</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <abnormal-table></abnormal-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="pagination-box">
      <a-pagination :total="ipagination.total" :page-size="ipagination.pageSize" :default-current="ipagination.current"
        :show-total="ipagination.showTotal" @showSizeChange="onShowSizeChange" @change="onChangeIpagination"
        show-size-changer show-quick-jumper />
    </div>
  </div>
</template>
<script>
import { abnormal } from "../method/abnormal";
import { staffListSelect } from "@/utils/api";
import abnormalTable from "../modules/abnormalTable";
export default {
  name: "abnormal",
  mixins: [abnormal],
  components: {
    abnormalTable,
  },
  data() {
    return {
      formData: {
        storesName: undefined,
        transactorName: undefined,
        code: null,
      },
      dateValue: null,
      agentList: [],
      storesList: [
        {
          name: "门店1",
        },
        {
          name: "门店2",
        },
      ],
      numObj: {
        notConfirm: 0,
        totalNumber: 0,
        yesConfirm: 0,
      },
    };
  },
  activated() {
    this.init();
    console.log("测试打印");
  },
  methods: {
    // 获取经办人列表
    getStaffListSelect() {
      let params = new FormData();
      params.append(
        "companyStoreId",
        this.$store.state.userInfo.companyStoreId
      );
      staffListSelect(params).then((res) => {
        if (res.code == 200) {
          this.agentList = res.result;
        } else {
          this.$message.error(res.logMessage);
        }
      });
    },
    // 选择筛选日期
    changeData(date, dateString) {
      this.dateValue = date;
      this.formData.startTime = dateString[0];
      this.formData.endTime = dateString[1];
    },
    // 选择经办人
    selectAgent(e) {
      this.formData.transactorId = this.agentList[e].id;
      this.formData.transactorName = this.agentList[e].name;
    },
    // 选择门店
    selectStores() {},
  },
};
</script>
<style lang="scss">
@import "../style/salesOrder.scss";
.abnormal-page {
  width: 100%;
  // 列表头部样式
  .inquire-module-list {
    height: 76px;
    padding: 0 25px;
    background-color: #ffffff;
    .ant-row {
      height: 80px !important;
      display: flex;
      align-items: center;
    }
    .button-ant-col {
      display: flex;
      .ant-btn {
        width: 80px !important;
      }
      .ant-btn-color {
        margin-right: 16px;
      }
    }
  }

  .sales-order-list-table {
    margin-top: 16px;
    background-color: #ffffff;
    .ant-table-fixed-left {
      .ant-table-body-inner {
        margin-right: -8px !important;
        margin-bottom: 0 !important;
      }
      .ant-table-body-outer {
        margin-bottom: 0 !important;
      }
    }
    .ant-table-fixed-right {
      .ant-table-body-outer {
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>
